<template>
  <CustomDialog
    v-model="dialog"
    ref="customDialog"
    backgroundColor="transparent"
    :persistent="false"
    hideHeader
    hideFooter
    fullscreen
    @cancel="close()"
  >
    <div
      v-if="dialog"
      class="d-flex flex-column fill-height fill-width align-center justify-center dialog-content"
    >
      <v-card
        class="card dialog-card"
        color="neutral2"
        width="30rem"
        @click="close()"
      >
        <v-btn icon absolute top right @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <div class="text-center">
          <div class="text-h5 font-weight-bold mb-2">
            🎁
            {{
              rewards.length > 1 ? "Presentes recebidos" : "Presente recebido"
            }}!
          </div>

          <div class="text-body-1 mb-6">
            Parabéns! 🎉 Você acaba de receber
            {{
              rewards.length > 1
                ? "alguns mimos especiais"
                : "um mimo especial"
            }}.
          </div>

          <v-window v-model="step">
            <v-window-item v-for="(item, i) in rewards" :key="i" :value="i + 1">
              <div class="d-flex align-center justify-space-around mb-2">
                <v-btn
                  v-if="rewards.length > 1"
                  class="btn"
                  color="white"
                  icon
                  @click="step--"
                  :disabled="step === 1"
                >
                  <v-icon x-large>mdi-chevron-left</v-icon>
                </v-btn>

                <v-img
                  v-if="
                    item?.item?.image ||
                    require(`@/assets/prizes/${item.type}.png`)
                  "
                  :src="
                    item?.item?.image ||
                    require(`@/assets/prizes/${item.type}.png`)
                  "
                  max-width="10rem"
                  class="rounded-lg"
                  contain
                />

                <v-btn
                  v-if="rewards.length > 1"
                  class="btn ml-2"
                  color="white"
                  icon
                  @click="step++"
                >
                  <v-icon x-large>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </v-window-item>
          </v-window>

          <div class="text-center font-weight-bold mb-6">
            {{ step }} de {{ rewards.length }}
          </div>

          <div>
            Todos os seus recebidos já estão no seu
            <span
              class="primary--text font-weight-bold pointer"
              @click="openInventory()"
              >inventário!</span
            >
          </div>
        </div>
      </v-card>

      <Confetti v-if="dialog" />
    </div>
  </CustomDialog>
</template>

<script>
import CustomDialog from "@/components/customDialog/CustomDialog";
import Confetti from "@/components/confetti/Confetti.vue";

export default {
  name: "GiftDialog",

  components: { CustomDialog, Confetti },

  data() {
    return {
      dialog: false,
      step: 1,
      rewards: [],
    };
  },

  methods: {
    open(data) {
      this.rewards = data;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    openInventory() {
      this.$root.$emit("open-inventory");
      this.close();
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
